export default "__VITE_ASSET__Drd327Zh__"